const getUserName = (user) => {
    if (!user) {
        return null;
    }

    if (user.shortName) {
        return user.shortName;
    }

    if (user.fullName) {
        return user.fullName.split(' ')[0];
    }

    return null;
};

module.exports = {
    getUserName,
};
